import {
  Component, ElementRef, EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit, Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

import { OptionValue } from '../../models/option-value';

@Component({
  selector: 'mcrai-option',
  template: `<div #content>
  <ng-content></ng-content>
</div>
`,
  styles: [`.mcrai-option{display:block;align-items:center;justify-content:flex-start;cursor:pointer;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:background-color .2s;padding:10px 20px;flex:0 0 44px;text-decoration:none;background:0;border:0;font-size:16px;text-align:left;outline:0;transition-timing-function:cubic-bezier(.25,.8,.25,1)}`],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-option]': 'true'
  }
})
export class OptionComponent implements OnInit {
  @HostBinding('class.mcrai-option--active') public isActive: boolean;

  @ViewChild('content') public content: ElementRef<any>;

  @Input() set value(value: string) {
    this._externalValue = value;
  }
  get value() {
    return this._externalValue;
  }

  @Output() selectionEvent: EventEmitter<OptionComponent> = new EventEmitter<OptionComponent>();

  private _internalValue: string;
  get internalValue(): string {
    return this._internalValue;
  }

  private _externalValue: string;
  get externalValue(): string {
    return this._externalValue;
  }

  constructor() { }

  ngOnInit() { }

  ngAfterViewInit() {
    this._internalValue = this._sanitazeTemplate(this.content.nativeElement.innerHTML);
  }

  private _sanitazeTemplate(template: string): string {
    return new DOMParser()
      .parseFromString(template, 'text/html')
      .documentElement
      .textContent
      .trim()
      .slice(0, 100)
      .replace(/\s\s+/g, ' ');
  }

  @HostListener('click')
  public onClick(): void {
    return this.selectionEvent.emit(this);
  }

}
